import React, { useState, useCallback } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import SubmitButton from 'Components/Form/SubmitButton'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import * as CONST from 'Reducers/Ambassador/const'
import style from './style'
import { TextField } from '@material-ui/core'
import { STATUS_PRE_ACCESS } from '../../../../../../../shared/constants'
import { updateOnSiteTraining } from '../../../../Ambasador/gql'
import SymbolsCounter from '../../../../../../../Components/SymbolsCounter'

const initialState = {
  comment: '',
}

function onSiteTrainingModal({
  classes,
  onSubmit,
  onCancel,
  ratedByUserId,
  userRated,
  isStatus = false,
}) {
  const [form, setForm] = useState(initialState)
  // ratingOption is a separated state because of the way the selectDashboard component is made
  const [ratingOption, setRatingOption] = useState('')
  const [disable, setDisable] = useState(false)

  const handleSubmitForm = async () => {
    const input = {
      rated_by: ratedByUserId,
      comment: form.comment,
      rating: ratingOption,
      user_rated: userRated,
    }
    await updateOnSiteTraining(input)
    await onSubmit({
      statusV2: STATUS_PRE_ACCESS,
      ...(isStatus && { status: STATUS_PRE_ACCESS }),
    })
  }

  const handleOnChangeForm = e => {
    const { name, value } = e.target
    setForm(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleFormSubmit = useCallback(() => {
    setDisable(true)
    handleSubmitForm()
  }, [handleSubmitForm])

  const options = CONST.RATING_AMBASSADOR_ON_SITE_TRAINING_OPTIONS.map(
    option => ({
      label: option,
      value: option,
    }),
  )
  const isSubmitFormDisabled = ratingOption.length === 0

  return (
    <Box display="flex" flexWrap="wrap" justifyContent="center" mt={3} mb={3}>
      <Box my={2} display="flex" width="100%" className={classes.input}>
        <SelectDashboard
          label="Rating:"
          input={{
            name: 'ratingOption',
            value: ratingOption,
            onChange: setRatingOption,
          }}
          options={options}
        />
      </Box>
      <Box
        my={2}
        display="flex"
        flexDirection="column"
        width="100%"
        alignItems="flex-start"
      >
        <TextField
          id="outlined-multiline-static"
          label="Comment"
          multiline
          variant="outlined"
          minRows={2}
          maxRows={10}
          inputProps={{ maxLength: 100 }}
          style={{ width: '100%' }}
          name="comment"
          onChange={handleOnChangeForm}
        />
        <SymbolsCounter valueToCounter={form.comment} symbolLimit="100" />
      </Box>
      <Box my={2} display="flex" width="100%" justifyContent="space-between">
        <SubmitButton value="cancel" onClick={onCancel} />
        <SubmitButton
          value="submit"
          disabled={isSubmitFormDisabled || disable}
          onClick={handleFormSubmit}
        />
      </Box>
    </Box>
  )
}

export default withStyles(style)(onSiteTrainingModal)
